import { MarkdownTextPrimitive } from '@assistant-ui/react-markdown';
import { Divider, Table, Title } from '@mantine/core';
import { motion } from 'motion/react';
import remarkGfm from 'remark-gfm';

import classes from './MarkdownText.module.css';

/**
 * Renders markdown content with Mantine-styled components and motion animations.
 * Bridges assistant-ui markdown primitives with the application's design system.
 */
export function MarkdownText() {
  return (
    <MarkdownTextPrimitive
      className={classes.markdownText}
      components={{
        table({ children }) {
          return <Table>{children}</Table>;
        },
        thead({ children }) {
          return <Table.Thead>{children}</Table.Thead>;
        },
        tbody({ children }) {
          return <Table.Tbody>{children}</Table.Tbody>;
        },
        tr({ children }) {
          return <Table.Tr>{children}</Table.Tr>;
        },
        th({ children }) {
          return <Table.Th>{children}</Table.Th>;
        },
        td({ children }) {
          return <Table.Td>{children}</Table.Td>;
        },
        hr() {
          return <Divider my="md" />;
        },
        h1({ children }) {
          return <Title order={1}>{children}</Title>;
        },
        h2({ children }) {
          return <Title order={2}>{children}</Title>;
        },
        h3({ children }) {
          return <Title order={3}>{children}</Title>;
        },
        h4({ children }) {
          return <Title order={4}>{children}</Title>;
        },
        h5({ children }) {
          return <Title order={5}>{children}</Title>;
        },
        h6({ children }) {
          return <Title order={6}>{children}</Title>;
        },
        p({ children }) {
          return <motion.p>{children}</motion.p>;
        },
        ol({ children }) {
          return <motion.ol>{children}</motion.ol>;
        },
        ul({ children }) {
          return <motion.ul>{children}</motion.ul>;
        },
        li({ children }) {
          return <motion.li>{children}</motion.li>;
        },
      }}
      remarkPlugins={[remarkGfm]}
    />
  );
}
